export default {
  SET_WORKSPACES(state, workspaces) {
    state.workspaces = [...workspaces];
  },

  SET_CURRENT_WORKSPACE(state, currIndex) {
    state.currWorkspaceIndex = currIndex;
  },

  TOGGLE_SIDEBAR(state) {
    state.isSidebarOpened = !state.isSidebarOpened;
  },

  TOGGLE_MODAL(state, modalName) {
    state.openModal = modalName;
  },

  CLEAR_PATIENT_SEARCH(state) {
    state.patientsSearched = [];
  },

  SEARCH_PATIENT(state, payload) {
    if (!payload.length) {
      state.patientsSearched = [];
    } else {
      state.patientsSearched = payload;
    }
  },

  SET_DUTY_LOADING(state, toLoading) {
    state.loadingDuty = toLoading;
  },

  SET_DUTY(state, toDuty) {
    state.isOnDuty = toDuty;
  },
};
